"use client";

import { useInView, useMotionValue, useSpring } from "framer-motion";
import { useEffect, useRef } from "react";

import { cn } from "@/lib/utils";

export default function NumberTicker({
  value,
  direction = "up",
  delay = 0,
  className,
  stiffness = 5,
  decimalPlaces = 0,
}: {
  value: number;
  direction?: "up" | "down";
  className?: string;
  delay?: number; // delay in s
  stiffness?: number;
  decimalPlaces?: number;
}) {
  const ref = useRef<HTMLSpanElement>(null);
  const motionValue = useMotionValue(direction === "down" ? Number(value) : 0);
  const springValue = useSpring(motionValue, {
    damping: 10,
    stiffness,
  });
  //@ts-ignore
  const isInView = useInView(ref, { once: false, margin: "-50px" });

  useEffect(() => {
    if (isInView) {
      const t = setTimeout(() => {
        motionValue.set(direction === "down" ? 0 : Number(value));
      }, delay * 1000);
      return () => {
        clearTimeout(t);
      }
    }
  }, [motionValue, isInView, delay, value, direction]);

  useEffect(
    () => {
      const unSubscribe = springValue.on("change", (latest) => {
        if (ref.current) {
          ref.current.textContent = Intl.NumberFormat("he-IL", {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces,
          }).format(Number(latest.toFixed(decimalPlaces)));
        }
      })
      return () => unSubscribe()
    },
    [springValue, decimalPlaces],
  );

  return (
    <span
      style={ {
        minWidth: value.toFixed(decimalPlaces).length * 0.7 + //number of letters x simulated width
          ~~((value).toFixed().length / 3) * 0.2 //number of "," x simulated width
          + "em"
      } }
      className={ cn(
        "inline-block tabular-nums tracking-wider text-center",
        className,
      ) }
      ref={ ref }
    >
      { motionValue.get().toLocaleString("he-IL") }
    </span>
  );
}
